//PaidListContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';


const PaidListContext = createContext();

export function PaidListProvider({ children }) {
  const [paidList, setPaidList] = useState([]);
  const [loadingList, setLoadingList] = useState(false);

  
  const fetchData = async () => {
    try {
      setLoadingList(true);
      const response = await fetch(`${config.apiBaseUrl}/payments/getPaidList.php`);
      const data = await response.json();
      setPaidList(data);
    } catch (error) {
      console.error('Error fetching fee data:', error);
    } finally {
      setLoadingList(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refreshList = () => {
    fetchData();
  };

  console.log(paidList);

  return (
    <PaidListContext.Provider value={{ paidList, loadingList, refreshList }}>
      {children}
    </PaidListContext.Provider>
  );
}

export function usePiadList() {
  const context = useContext(PaidListContext);
  if (context === undefined) {
    throw new Error('usePiadList must be used within a PaidListProvider');
  }
  return context;
}
